<template>
  <div class="stu-report-refactor scroll-container">
    <div class="scroll-page">
      <div class="top flex-align">
        <img src="@/assets/report/redLogo.png" alt="" class="logo" />
      </div>
      <div class="report-time">
        <div class="download flex-align">
          <i class="el-icon-download" @click="getUserpdf" v-if="reportStatus == 0"> 生成个人报告</i>
          <span v-if="reportStatus == 1"> 报告生成中 <i class="el-icon-loading"></i></span>
          <i class="el-icon-download" @click="downloadPdf('btn')" v-if="reportStatus == 2"> 下载个人报告</i>
        </div>
        <div class="ReportGenerationTime">
          <span>学期：{{ $route.query.termKeyName }}</span>
          <span>报告时间：{{ currentTime }}</span>
        </div>
      </div>
      <h4 class="title">{{ reportInfo.userName }}同学的测评报告</h4>
      <div class="main-wrapper">
        <div class="main">
          <div class="top-panel flex-align-between">
            <ul class="flex-align score-list">
              <li class="score-item">
                <div class="score-card-inner">
                  <p class="score-value">
                    <span class="score-main-num">{{ formatPrimaryStat(statCards[0]) }}</span>
                    <span class="score-unit">{{ statCards[0].unit }}</span>
                  </p>
                  <p class="score-name" :class="{ 'score-name--empty': !statCards[0].label }">
                    <template v-if="statCards[0].label">{{ statCards[0].label }}</template>
                    <template v-else>&nbsp;</template>
                  </p>
                </div>
              </li>
              <li class="score-item">
                <div class="score-card-inner">
                  <p class="score-value">
                    <span class="score-main-num">{{ accuracyPercentDisplay.num }}</span>
                    <span v-if="accuracyPercentDisplay.symbol" class="score-unit">{{ accuracyPercentDisplay.symbol
                    }}</span>
                  </p>
                  <p class="score-name">正确率({{ accuracyRatioDisplay }})</p>
                </div>
              </li>
              <li class="score-item">
                <div class="score-card-inner">
                  <p class="score-value">
                    <span class="score-main-num">{{ formatPrimaryStat(statCards[2]) }}</span>
                    <span class="score-unit">{{ statCards[2].unit }}</span>
                  </p>
                  <p class="score-name" :class="{ 'score-name--empty': !statCards[2].label }">
                    <template v-if="statCards[2].label">{{ statCards[2].label }}</template>
                    <template v-else>&nbsp;</template>
                  </p>
                </div>
              </li>
            </ul>
            <div class="line"></div>
            <img :src="integrationLevelMap[reportInfo.integrationLevel]" alt="" class="level" />
          </div>
          <div class="bottom-panel flex-between">
            <div class="panel-item">
              <h5>书写平均成绩</h5>
              <el-table :data="tableData1" stripe show-summary :summary-method="getTableAverage" sum-text="全部"
                class="table">
                <el-table-column prop="structure" label="分类" align="center">
                </el-table-column>
                <el-table-column prop="gridSize" label="占格" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.gridSize > 0 ? scope.row.gridSize : '--' }}
                  </template>
                </el-table-column>
                <el-table-column prop="comboRel" label="结构" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.comboRel > 0 ? scope.row.comboRel : '--' }}
                  </template>
                </el-table-column>
                <el-table-column prop="strokeRel" label="笔画" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.strokeRel > 0 ? scope.row.strokeRel : '--' }}
                  </template>
                </el-table-column>
                <el-table-column prop="glyphGrav" label="重心" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.glyphGrav > 0 ? scope.row.glyphGrav : '--' }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="panel-item">
              <h5>书写等级分布情况</h5>
              <el-table :data="tableData2" stripe show-summary sum-text="全部" class="table">
                <el-table-column prop="structure" label="分类" align="center"></el-table-column>
                <el-table-column prop="total" label="总字数" align="center"> </el-table-column>
                <el-table-column prop="level4" label="优秀" align="center"> </el-table-column>
                <el-table-column prop="level3" label="良好" align="center"> </el-table-column>
                <el-table-column prop="level2" label="合格" align="center"> </el-table-column>
                <el-table-column prop="level1" label="待提升" align="center"> </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="scroll-page">
      <div class="main-wrapper second-wrapper">
        <div class="main second-main flex-column">
          <div class="top-module">
            <div class="toolbar flex-between">
              <button class="test-paper-btn csp" @click="showImgPreview">点击查看原试卷</button>
              <el-image ref="imagePreview" class="img-preview" style="width: 100px; height: 100px"
                :src="reportInfo.imgList[0]" :preview-src-list="reportInfo.imgList">
              </el-image>
              <ul class="flex-align structure-list">
                <li v-for="(item, index) in wordStructureList" :key="index" class="structure-item flex-align"
                  :class="{ active: activeStructure === index }" @click="switchStructure(item, index)">
                  <img :src="activeStructure === index ? item.activeIcon : item.icon" alt="" class="structure-icon" />{{
                    item.name }}
                </li>
              </ul>
            </div>
            <div class="all-words">
              <div class="flex-align-between">
                <div class="checked-group">
                  <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选
                  </el-checkbox>
                  <el-checkbox-group v-model="checkedList" @change="handleChecked" style="display: inline-block">
                    <el-checkbox v-for="city in checkedOptions" :label="city.value" :key="city.value">{{ city.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div class="filter-right flex-align">
                  <button type="button" class="recognition-fail-btn csp" :class="{ active: recognitionFailedOnly }"
                    @click="showRecognitionFailed">识别失败</button>
                  <span class="tips"><img src="../../assets/report/click.png" alt="" />【点击单字查看书写评价】</span>
                </div>
              </div>
              <ul class="words">
                <li class="word-item" v-for="(item, index) in wordList" :key="wordRowKey(item, index)"
                  :class="{ activeWord: activeWord === index }" @click="selecedWord(item, index)">
                  <img class="word-img" src="../../assets/assistant/tian.png" alt="十字格子" />
                  <img class="word-img" :src="item.wordSkillCover" alt="技巧" />
                  <img class="word-img" :src="item.wordShadowCover" alt="阴影" />
                  <img class="word-img" v-if="item.resFilename" :src="item.resFilename" alt="手写字" />
                  <div class="score-bg" v-if="item.integration && Number(item.integration) > 0">
                    <img src="../../assets/report/score.png" alt="" />
                    <span class="score">{{ handleScore(item) }}</span>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="bottom-module flex-column">
            <h5>单字点评</h5>
            <div class="comment flex-column">
              <!-- 评分模块 -->
              <div class="score-header flex-align-between">
                <div class="dimension-scores flex-align-center">
                  <div v-for="(item, index) in scores" :key="index" class="dimension-scores-item">
                    <img :src="item.label" alt="" class="dimension-scores-label" />
                    <div class="dimension-scores-value">{{ item.value }}</div>
                  </div>
                </div>
              </div>
              <!-- 对比模块 -->
              <div class="character-comparison flex-align-between">
                <button :class="['left-btn', 'csp', { 'able': isPreAble }]" @click="preWord"><i
                    class="el-icon-arrow-left"></i></button>
                <ul class="characers flex-align-between">
                  <li class="characer" v-for="(item, index) in characerMap" :key="index">
                    <p class="characer-title">{{ item.title }}</p>
                    <div class="characer-item">
                      <img v-for="(sItem) in item.imgs" :key="sItem" :src="sItem" alt="" class="characer-img" />
                    </div>
                  </li>
                </ul>
                <button :class="['left-btn', 'csp', { 'able': isNextAble }]" @click="nextWord"><i
                    class="el-icon-arrow-right"></i></button>
              </div>
            </div>
          </div>
          <div class="bottom-module flex-column">
            <h5>历次书写测评能力对比分析</h5>
            <div class="StudentMatrix">
              <div class="StudentMatrix_title flex-align-center">
                学生测评矩阵分布图
              </div>
              <div class="StudentMatrix-box" v-if="ownexam.length > 0 && CurrentEvaluationId">
                <FourSymbolsLineDiagram id_type="StudentMatrix" :ownexamData="ownexam" :username="$route.query.name"
                  :CurrentEvaluationId="CurrentEvaluationId" :reportType="reportType" :GradeValue="grade">
                </FourSymbolsLineDiagram>
              </div>
              <div class="StudentMatrix-box flex-align-center" v-else>
                <el-empty description="暂无数据"></el-empty>
              </div>
            </div>
          </div>
          <div class="bottom-module flex-column">
            <div class="SummaryAndSuggestions">总结与建议</div>
            <div class="Content">
              <!-- 双优型（第一象限稳定） -->
              <template v-if="reportType == '双优型'">
                <p class="SummaryAndSuggestions_text">
                  你始终保持着优秀的努力习惯与出色的天赋表现，是班级的榜样！你的稳定进步让我们看到坚持的力量。若能尝试挑战更高难度的任务，你的潜力将更加耀眼。继续保持这份卓越，未来定会更加精彩！</p>
                <div class="Whole">整体来看</div>
                <p class="SummaryAndSuggestions_text">
                  1、你的多横、多竖的间距偶尔有细微偏差，破坏了笔画排布的视觉均匀感，导致字的整体书写秩序感不够稳定；建议开展精细控笔训练，重点提升笔画书写质感与位置精细度，尤其强化多画等距不同间距精度；针对书写不足制定专项训练计划：若起收细节不到位导致间距精度偏差，则集中练习其收笔力度与位置控制；若多笔画交叉拥挤，重点练习交叉笔画间距分配。​
                </p>
                <p class="SummaryAndSuggestions_text">
                  2、你的部分笔画过于拥挤或放得太开，对收放的把控不够精准，无法让笔画形成疏密的排布节奏，字体略显呆板。建议书写前认真观察笔画位置关系、呼应形态、长度比例及疏密层次，将书写规律深度内化，同时针对细节问题不断调整，让手部形成肌肉记忆、大脑养成书写规律意识，为未来快速书写夯实基础；通过持续优化，让大脑养成符合书写规律的疏密排布意识。
                </p>
              </template>
              <!-- 稳定进步型(稳健型) -->
              <template v-if="reportType == '稳健型'">
                <p class="SummaryAndSuggestions_text">
                  你一步一个脚印的踏实进步令人赞叹！每一次测评都能看到你的持续成长，这份韧性非常可贵。相信只要保持现在的节奏，你的天赋维度也会逐渐绽放光芒。继续稳步前行，成功终将水到渠成！</p>
                <div class="Whole">整体来看</div>
                <p class="SummaryAndSuggestions_text"> 1、你的部分字出现字的重心偏移的现象；建议加强对重心维度的理解，利用田字格的横中线和竖中线，建立字的中心轴，从而让字均衡平稳。</p>
                <p class="SummaryAndSuggestions_text"> 2、你的多画的间距，逐渐均匀但经细致还需要提升；建议加强控笔练习，提升笔画精细度，让笔画间距均匀稳定。</p>
                <p class="SummaryAndSuggestions_text"> 3、你的笔画位置关系相对准确，但偶尔会出现顾此失彼；建议写前认真观察，注意留心笔画位置关系，笔画间的呼应和主次的层次关系。</p>
                <p class="SummaryAndSuggestions_text"> 4、你的收放长短对比清晰，空间疏密的细节需要提升。建议书写前认真观察，字的疏密区域，根据书写规律布局笔画。</p>
              </template>
              <!-- 努力显著进步型(进取型) -->
              <template v-if="reportType == '进取型'">
                <p class="SummaryAndSuggestions_text">
                  你的努力程度令人感动！通过不懈坚持，你在努力维度取得了显著提升，这充分证明了“天道酬勤”。如果能在保持努力的同时，探索更适合自己的学习方法，你的天赋潜力一定会被进一步激发。加油，你的付出终会收获回报！</p>
                <div class="Whole">整体来看</div>
                <p class="SummaryAndSuggestions_text">
                  1、复合字穿插避让不够准确，各部之间宽窄长短比例略有偏差，以及间距忽大忽小，衔接不自然。建议书写前认真观察，并牢记部首书写规律，前期可以在田字格内，用铅笔轻轻画分部部件间的位置关系，书写时注意避让，遵循左部右侧笔画紧收让右，右部左侧笔画紧收让左；
                </p>
                <p class="SummaryAndSuggestions_text">
                  2、占格居中不稳定，出现过大过小以及占格偏斜等问题。建议书写前认真观察字上下左右的笔画与格的间距，以及主笔和中心笔画。辅助定位，逐步调整字与格的关系，做到占位居中，大小一致。</p>
                <p class="SummaryAndSuggestions_text">3、多画等距不稳定，笔画需平行且间距视觉侧面均等。建议加强控笔练习，通过手腕手指的灵活练习，逐步提升笔画间距的一致性；</p>
                <p class="SummaryAndSuggestions_text">
                  4、大部分字的重心都趋于稳定，但仍有个别字的重心出现失衡现象。建议在做到横平竖直的同时，可以通过田字格的横中心和竖中线，辅助建立字的中心轴，让复合字可以上下对正，且左右对称或均衡。</p>
              </template>
              <!-- 天赋型 -->
              <template v-if="reportType == '天赋型'">
                <p class="SummaryAndSuggestions_text">
                  你是一位很有书写天赋的同学，对汉字结构和重心有着很强的领悟力，一点就通、学得很快，这是你非常突出的优势！只要再把细节练扎实、把复杂字练熟练，你的书写水平会更上一层楼。</p>
                <div class="Whole">整体来看</div>
                <p class="SummaryAndSuggestions_text">
                  你的笔画平稳，简单的横竖等距、主笔收放都掌握得不错，独体字和大部分复合字的重心也很稳，观察能力很强，能准确找准笔画位置。但在一些细节和复杂字形上还可以做得更好，老师给你几个小建议：
                </p>
                <p class="SummaryAndSuggestions_text">
                  1、多留意撇、点等不同角度笔画的细节，把同一个字里的笔画间距写得更均匀细腻，让等距效果更精准好看；
                </p>
                <p class="SummaryAndSuggestions_text">
                  2、多学习复合字的组合规律，理解部件之间的搭配关系，让字的疏密层次更清晰，收放更自然；
                </p>
                <p class="SummaryAndSuggestions_text">
                  3、学会更细致的观察方法，拆解复杂字的结构和笔画位置，把每个字写得大小合适、稳稳居中在格子里。
                  坚持针对性练习，把优势稳住、把细节补齐，你会写出更工整漂亮的字！
                </p>
              </template>
              <!-- 天赋退步型(潜能型) -->
              <template v-if="reportType == '潜能型'">
                <p class="SummaryAndSuggestions_text">
                  你拥有良好的基础和能力，近期可能遇到了一些挑战，但这只是暂时的调整期。老师相信你的天赋潜力，只要找到适合自己的方法，稍加调整，一定能重拾最佳状态。别忘了，你的努力一直很稳定，这是你最宝贵的财富！</p>
                <div class="Whole">整体来看</div>
                <p class="SummaryAndSuggestions_text">
                  1、你的字中心偏离田字格交点，占格过大；建议写每个字前，标记字的中心笔画和田字格交点，每天练12个字；写完后观察田字格边框与字四周笔画的位置关系，尽量让上下间距一致，左右距离均等，保证字在格子里不偏左也不偏右。
                </p>
                <p class="SummaryAndSuggestions_text">
                  2、你之前收放把控得好，现在要么收得太紧，要么放得太开；建议寻找主笔和舒展的笔画，进行主次笔长短对比，以及字疏密布局的观察，默念书写规律后在下笔。</p>
                <p class="SummaryAndSuggestions_text">
                  3、你的多画间距有些不一致，过大或多小；建议加强控笔练习，书写时注意笔画间距一致，且笔画之间保持平行，角度变化也会导致等距视觉的均衡感的缺失。</p>
                <p class="SummaryAndSuggestions_text">
                  4、你的部件之间间距把握不太准确，穿插避让不到位。建议书写前先默念部首规律，划分部件之间的区域，遵循左部右侧紧收让右，右侧左部紧收让左，上部下方近齐让下，下方上部笔画缩短避让。并根据组合规律每天临写练习8个字，纠正偏差。
                </p>
              </template>
              <!-- 波动型 -->
              <template v-if="reportType == '波动型'">
                <p class="SummaryAndSuggestions_text">
                  你是一个充满潜力的学生，表现虽有波动，但这正说明你有很大的提升空间！每次变化都是宝贵的经验，学会从波动中寻找规律，你会变得更加沉稳。老师会一直支持你，让我们一起找到最适合你的学习节奏！</p>
                <div class="Whole">整体来看</div>
                <p class="SummaryAndSuggestions_text">
                  你的书写中会有些不稳定，如练 “居中” 时就顾不上 “重心”，练 “重心”
                  时笔画又写歪；换着练不同的字时，笔画角度（比如撇捺的倾斜度）、用力大小会变，不稳定；调整部首和部件的组合时，笔画位置总是找不着的问题，这是给你的几个小建议：
                </p>
                <p class="SummaryAndSuggestions_text">1、首先你要养成观察习惯，找准中心笔画和四周笔画，确定字与格子的位置关系，稳定居中占格；</p>
                <p class="SummaryAndSuggestions_text">2、你要加强控笔练习，提升等距维度好的同时，养成书横平竖直的书写习惯，解决大部分重心问题；</p>
                <p class="SummaryAndSuggestions_text">
                  3、还要熟记部首书写规律，在书写复合字时做到，相互避让，左让右，上让下。半包围留空小，全包围留空隙的组合习惯。当以上问题稳定后再逐一解决其它维度，让书写逐步稳定提升。</p>
              </template>
              <!-- 需关注型(重点型) -->
              <template v-if="reportType == '重点型'">
                <p class="SummaryAndSuggestions_text">
                  你正在经历一段调整期，但这并不代表你的能力不足。每个人都有自己的成长节奏，你的每一次尝试都值得肯定。请记住，老师看到了你的坚持，也相信你的潜力。从小目标开始，慢慢积累，你一定会迎来属于自己的突破！</p>
                <div class="Whole">整体来看</div>
                <p class="SummaryAndSuggestions_text">
                  1、从你的字迹中，看到了你认真努力的样子。接下来我们可以通过一些小技巧来让书写变得简单起来。例如我们可以在田字格内侧贴一圈细胶带（当“边界线”），书写时确保笔画不碰到胶带，每天练15个字；让我们一起通关占格这个小挑战。
                </p>
                <p class="SummaryAndSuggestions_text">
                  2、你的笔画微斜，不是你不够认真。有可能是你的姿势不正确呦！在我们练习控笔前，先调整正确的双姿，做到发力正确，练习手腕手指协调性，这时候书写中的横平竖直，和转折清晰是不是变得很简单了？</p>
                <p class="SummaryAndSuggestions_text"> 3、要是觉得写字没头绪，不知道如何收放，先别急。咱们先来玩个 “找主笔” 的小把戏呗！试着让主笔 “冒出头”
                  更显眼，笔画之间也像搭积木似的有顺序，每天练 20 个笔画，慢慢就会发现，写字越来越顺啦！</p>
              </template>
              <div class="Whole">具体问题与建议:</div>
              <div class="Whole_Details" v-for="(item, index) in commentList" :key="index">
                <p class="SummaryAndSuggestions_text">
                  <span>{{ index + 1 }}、《{{ item.name }}》</span>
                  <span>{{ item.comment }}</span>
                </p>
                <p class="SummaryAndSuggestions_text">{{ item.method }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * 学生个人测评报告页
 * 数据流概览：
 * 1. getStuData — 总览指标、表格、结构 Tab、试卷图
 * 2. getUserWordsRecord + switchStructure / 筛选 — 单字列表与当前字详情
 * 3. getStuCompareData — 历次测评散点 ownexam，并计算象限统计供报告类型判定
 * 4. findLowestWithComments — 按维度最低分生成「具体问题与建议」列表
 * 5. getowntypebyclass — 结合班级统计接口判定 reportType，驱动总结文案模板
 * 6. getUserpdf / downloadPdf — 个人 PDF 生成与轮询下载
 */
import moment from "moment";
import FourSymbolsLineDiagram from './FourSymbolsLineDiagram'
import axios from 'axios';
import {
    classifyQuadrantIndex,
    getGradeFromTermId,
    resolveItemGrade,
} from './quadrantGradeAxis';
export default {
  components: {
    FourSymbolsLineDiagram
  },
  computed: {
    // 合并所有测评的所有评语，每条为 { issue, solution } 对象
    mergedCommentPairs() {
      const allPairs = [];
      const list = Array.isArray(this.evaluations) ? this.evaluations : [];
      list.forEach((evaluation) => {
        const comments = evaluation && Array.isArray(evaluation.comments) ? evaluation.comments : [];
        comments.forEach((comment) => {
          allPairs.push({
            issue: comment.issue,
            solution: comment.solution
          });
        });
      });
      return allPairs;
    },
    accuracyPercentDisplay() {
      return this.formatAccuracyPercent(this.statCards[1].accuracyPercent);
    },
    accuracyRatioDisplay() {
      return this.formatAccuracyRatio(this.statCards[1].ratioText);
    },
  },
  watch: {
    $route: {
      handler() {
        this.syncPreviewFlagFromRoute();
      },
      immediate: false,
      deep: false
    }
  },
  data() {
    return {
      isPreview: false,
      table_type: '',
      /** 独立「识别失败」模式：与左侧等级多选互斥 */
      recognitionFailedOnly: false,
      checkAll: true,
      checkedList: [1, 2, 3, 4],
      checkedOptions: [{
        label: "优秀",
        value: 4,
      },
      {
        label: "良好",
        value: 3,
      },
      {
        label: "合格",
        value: 2,
      },
      {
        label: "待提升",
        value: 1,
      },
      ],
      isIndeterminate: false,

      currentTime: "",
      wordList: [],
      status: {
        4: "优秀",
        3: "良好",
        2: "合格",
        1: "待提升",
      },
      /** 首页顶部三块指标（假数据占位；getStuData 内会覆盖为接口数据） */
      statCards: [
        {
          cardType: 'count',
          value: '',
          unit: '字',
          label: '书写测评',
        },
        {
          cardType: 'accuracy',
          ratioTitle: '正确字数 / 总字数',
          ratioText: '',
          accuracyPercent: '',
          label: '',
        },
        {
          cardType: 'count',
          value: 0,
          unit: '分',
          label: '平均得分',
        },
      ],
      integrationLevelMap: {
        1: require("../../assets/report/needs- improvement.png"),
        2: require("../../assets/report/pass.png"),
        3: require("../../assets/report/good.png"),
        4: require("../../assets/report/excellent.png"),
      },
      tableData1: [],
      /** writeAvgScore 中 structure 为「全部」的汇总行，用于表格底部合计 */
      tableData1Summary: null,
      tableData2: [],
      activeStructure: 0,
      wordStructureList: [{
        name: "全部",
        icon: require("../../assets/report/word-all.png"),
        activeIcon: require("../../assets/report/white-word-all.png"),
      },],
      staticStructureMap: {
        上下结构: {
          name: "上下",
          code: "上下结构",
          icon: require("../../assets/report/structure-1.png"),
          activeIcon: require("../../assets/report/white-structure-1.png"),
        },
        左右结构: {
          name: "左右",
          code: "左右结构",
          icon: require("../../assets/report/structure-2.png"),
          activeIcon: require("../../assets/report/white-structure-2.png"),
        },
        半包围结构: {
          name: "半包围",
          code: "半包围结构",
          icon: require("../../assets/report/structure-3.png"),
          activeIcon: require("../../assets/report/white-structure-3.png"),
        },
        独体结构: {
          name: "独体字",
          code: "独体结构",
          icon: require("../../assets/report/structure-4.png"),
          activeIcon: require("../../assets/report/white-structure-4.png"),
        },
        上中下结构: {
          name: "上中下",
          code: "上中下结构",
          icon: require("../../assets/report/structure-5.png"),
          activeIcon: require("../../assets/report/white-structure-5.png"),
        },
        全包围结构: {
          name: "全包围",
          code: "全包围结构",
          icon: require("../../assets/report/structure-6.png"),
          activeIcon: require("../../assets/report/white-structure-6.png"),
        },
        左中右结构: {
          name: "左中右",
          code: "左中右结构",
          icon: require("../../assets/report/structure-7.png"),
          activeIcon: require("../../assets/report/white-structure-7.png"),
        },
        框架结构: {
          name: "框架",
          code: "框架结构",
          icon: require("../../assets/report/structure-8.png"),
          activeIcon: require("../../assets/report/white-structure-8.png"),
        },
      },
      activeWord: 0,
      xiangxian1: 0,
      xiangxian2: 0,
      xiangxian3: 0,
      xiangxian4: 0,
      countall: 0,
      reportInfo: {
        imgList: ['']
      },
      selectStructure: null,
      scores: [{
        label: require("../../assets/report/grid.png"),
        value: '--'
      },
      {
        label: require("../../assets/report/structure.png"),
        value: '--'
      },
      {
        label: require("../../assets/report/stroke.png"),
        value: '--'
      },
      {
        label: require("../../assets/report/balance.png"),
        value: '--'
      },
      ],
      characerMap: [{
        id: 1,
        title: "原字",
        imgs: []
      },
      {
        id: 2,
        title: "待测字",
        imgs: []
      },
      {
        id: 3,
        title: "AI智能对比",
        imgs: []
      },
      ],
      defaultWordInfo: {
        word: null,
        gridSize: null,
        glyphGrav: null,
        strokeRel: null,
        comboRel: null,
        integration: null,
        imagePath: null,
        resFilename: null,
        wordCover: null,
        wordShadowCover: null,
        wordSkillCover: null,
      },
      currentWord: {},
      isPreAble: false,
      isNextAble: false,
      reportStatus: 0,
      time: null,
      ownexam: [],
      reportType: '',
      CurrentEvaluationId: null,
      evaluations: [],
      commentList: [],
      tianGridBg: require('../../assets/assistant/tian.png'),
      grade:null,
    };
  },
  methods: {
    wordRowKey(item, index) {
      const id =
        item && item.resFilename != null && item.resFilename !== ''
          ? String(item.resFilename)
          : item && item.word != null
            ? String(item.word)
            : 'row';
      return `${id}-${index}`;
    },
    formatPrimaryStat(item) {
      const val = item.value;
      if (val === '--' || val === null || val === undefined) return '--';
      if (typeof val === 'number' && item.unit === '分') {
        return Number(val).toFixed(2);
      }
      return val;
    },
    formatAccuracyPercent(percent) {
      if (percent === '--' || percent === null || percent === undefined || percent === '') {
        return { num: '--', symbol: '' };
      }
      const str = String(percent);
      if (str.endsWith('%')) {
        return { num: str.slice(0, -1), symbol: '%' };
      }
      return { num: str, symbol: '%' };
    },
    formatAccuracyRatio(ratioText) {
      if (!ratioText) return '--/--';
      return String(ratioText).replace(/\s/g, '');
    },
    parsePreviewFlag(val) {
      return val === true || val === 'true' || val === 1 || val === '1';
    },
    syncPreviewFlagFromRoute() {
      const q = this.$route.query;
      const queryPreview = q?.preview;
      const paramsPreview = this.$route?.params?.preview;
      const rawPreview = queryPreview !== undefined ? queryPreview : paramsPreview;
      this.isPreview = this.parsePreviewFlag(rawPreview);
      if (q.table_type !== undefined && q.table_type !== '') {
        this.table_type = q.table_type;
      }
    },
    /** 与 report_whole 一致：preview 且新版(table_type=2) 时追加 preview；主数据接口可先带 preview（ignoreTableType） */
    withPreview(data, options = {}) {
      const ignoreTableType = options.ignoreTableType === true;
      if (!this.isPreview) return data;
      if (ignoreTableType || String(this.table_type) === '2') {
        return { ...data, preview: true };
      }
      return data;
    },
    handleCheckAllChange(val) {
      this.recognitionFailedOnly = false;
      this.checkedList = val ? [1, 2, 3, 4] : [];
      this.isIndeterminate = false;
      if (this.checkedList.length === 0) {
        this.wordList = [];
        this.currentWord = this.defaultWordInfo;
        this.changeCurrentWord()
        return;
      }
      this.getUserWordsRecord();
    },
    handleChecked(value) {
      // 进入「仅识别失败」时会清空左侧勾选；若此时触发 [] 的 change，不能关掉 recognitionFailedOnly，否则后续请求会带上空的 integrationLevelList
      if (value.length === 0 && this.recognitionFailedOnly) {
        return;
      }
      this.recognitionFailedOnly = false;
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.checkedOptions.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.checkedOptions.length;
      if (value.length === 0) {
        this.wordList = [];
        this.currentWord = this.defaultWordInfo;
        this.changeCurrentWord();
        return;
      }
      this.getUserWordsRecord();
    },
    /** 仅看识别失败：左侧等级全部不选；再点全选/等级则退出本模式 */
    showRecognitionFailed() {
      this.recognitionFailedOnly = true;
      this.checkAll = false;
      this.checkedList = [];
      this.isIndeterminate = false;
      this.getUserWordsRecord();
    },

    /** 第一页总览：指标、等级分布表、结构 Tab、试卷预览图 */
    async getStuData() {
      let data = {
        termKey: this.$route.query.termKey, // 20232,
        userId: this.$route.query.userId, // 390990,
        examType: this.$route.query.reportValue, // 1前测 2后测 4月测
        // testId: this.$route.query.monthValue,
        defType: this.$route.query.monthValue,
      };
      data = this.withPreview(data, { ignoreTableType: true });
      let resData = await this.$Api.Report.getStuDataV2(data);
      const reportInfo = resData.data;
      this.reportInfo = resData.data;
      this.CurrentEvaluationId = reportInfo.test_id;
      // 配置第一页：顶部三块指标（getStuDataV2：wordCount 书写总数、correctWordCount 正确字数、integrity 正确率、avgScore 平均分）
      const numOrNull = (v) => {
        if (v === undefined || v === null || v === '') return null;
        const n = Number(v);
        return Number.isNaN(n) ? null : n;
      };
      const wc = numOrNull(reportInfo.wordCount);
      const cc = numOrNull(reportInfo.correctWordCount);
      const integ = numOrNull(reportInfo.integrity);
      const avg = numOrNull(reportInfo.avgScore);

      this.statCards[0].value = wc !== null ? wc : '--';
      if (wc !== null && cc !== null) {
        this.statCards[1].ratioText = `${cc}/${wc}`;
      } else {
        this.statCards[1].ratioText = '--/--';
      }
      if (integ !== null) {
        this.statCards[1].accuracyPercent = `${Number.isInteger(integ) ? integ : Number(integ).toFixed(2)}%`;
      } else {
        this.statCards[1].accuracyPercent = '--';
      }
      this.statCards[2].value = avg !== null ? avg : '--';
      const writeAvg = Array.isArray(reportInfo.writeAvgScore) ? reportInfo.writeAvgScore : [];
      this.tableData1Summary = writeAvg.find((item) => item.structure === "全部") || null;
      this.tableData1 = writeAvg.filter((item) => item.structure !== "全部");
      const levelDist = Array.isArray(reportInfo.levelDist) ? reportInfo.levelDist : [];
      const newTabledata2 = levelDist.filter((item) => item.structure !== "全部");
      this.tableData2 = newTabledata2;
      // 配置第二页
      const newStructureList = [];
      const structureList = Array.isArray(reportInfo.structureList) ? reportInfo.structureList : [];
      structureList.forEach((item) => {
        const mapped = this.staticStructureMap[item];
        if (mapped) newStructureList.push(mapped);
      });
      this.wordStructureList = [...this.wordStructureList, ...newStructureList];
    },
    /** 按当前结构 Tab + 等级筛选拉取单字列表，默认展示首字 */
    async getUserWordsRecord() {
      const integrationLevelList = this.recognitionFailedOnly
        ? [-1]
        : this.checkedList;
      let data = {
        termKey: this.$route.query.termKey, // 20232,
        userId: this.$route.query.userId, // 390990,
        examType: this.$route.query.reportValue, // 1前测 2后测 4月测
        // testId: this.$route.query.monthValue,
        defType: this.$route.query.monthValue,
        structure: this.selectStructure,
        integrationLevelList,
      };
      data = this.withPreview(data, { ignoreTableType: true });
      let resData = await this.$Api.Report.getWordByStructure(data);
      const wordList = resData.data;
      if (!wordList || wordList.length < 1) {
        this.wordList = [];
        this.currentWord = this.defaultWordInfo;
        this.changeCurrentWord()
        console.error("子列表为空 request data:", data);
        return;
      }
      this.wordList = wordList;
      if (wordList && wordList.length > 0) {
        this.currentWord = wordList[0];
        this.changeCurrentWord();
        this.activeWord = 0
      }
    },
    handleScore(item) {
      return Number(item.integration).toFixed(0);
    },
    // 选择文字结构
    switchStructure(item, index) {
      this.activeStructure = index;
      this.selectStructure = index === 0 ? null : this.wordStructureList[index].code;
      this.getUserWordsRecord();
    },
    selecedWord(item, index) {
      this.activeWord = index;
      this.currentWord = item;
      this.changeCurrentWord();
    },
    /** 同步当前单字的四维分数、对比图与上一字/下一字按钮状态 */
    changeCurrentWord() {
      const cw = this.currentWord || {};
      this.scores[0].value = cw.gridSize > 0 ? cw.gridSize : '--';
      this.scores[1].value = cw.comboRel > 0 ? cw.comboRel : '--';
      this.scores[2].value = cw.strokeRel > 0 ? cw.strokeRel : '--';
      this.scores[3].value = cw.glyphGrav > 0 ? cw.glyphGrav : '--';
      const bg = this.tianGridBg;
      this.characerMap[0].imgs = [bg, cw.wordCover].filter(Boolean);
      this.characerMap[1].imgs = [bg, cw.resFilename].filter(Boolean);
      this.characerMap[2].imgs = [bg, cw.wordSkillCover, cw.wordShadowCover, cw.resFilename].filter(Boolean);
      this.starValue = cw.integration && Number(cw.integration) > 0
        ? this.computeLevel(Number(cw.integration))
        : 0;
      this.isNextAble = this.activeWord < (this.wordList.length - 1)
      this.isPreAble = this.activeWord > 0
    },
    nextWord() {
      this.activeWord++;
      this.currentWord = this.wordList[this.activeWord]
      this.changeCurrentWord();
    },
    preWord() {
      this.activeWord--;
      this.currentWord = this.wordList[this.activeWord]
      this.changeCurrentWord();
    },
    computeLevel(score) {
      if (score >= 85) {
        return 4
      }
      if (score >= 70 && score < 85) {
        return 3
      }
      if (score >= 60 && score < 70) {
        return 2
      }
      if (score < 60) {
        return 1
      }
      return 5
    },

    showImgPreview() {
      const imgElement = this.$refs.imagePreview.$el.querySelector('img');
      if (imgElement) {
        imgElement.click();
      }
    },
    formatWriteAvgCell(value) {
      const n = Number(value);
      if (value === null || value === undefined || value === '' || Number.isNaN(n) || n <= 0) {
        return '--';
      }
      return Number.isInteger(n) ? String(n) : n.toFixed(2);
    },
    getTableAverage(param) {
      const { columns } = param;
      const sums = [];
      const summaryRow = this.tableData1Summary;

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "全部";
          return;
        }
        if (!summaryRow) {
          sums[index] = '--';
          return;
        }
        sums[index] = this.formatWriteAvgCell(summaryRow[column.property]);
      });

      return sums;
    },
    /** 触发生成 PDF，成功后轮询 downloadPdf 直至文件就绪 */
    async getUserpdf() {
      let data = {
        userId: this.$route.query.userId,
        termIndex: this.$route.query.termKey,
        examType: this.$route.query.reportValue,
        examId: this.$route.query.monthValue,
        version: this.$route.query.term_type
      }
      data = this.withPreview(data, { ignoreTableType: true });
      let resData = await this.$Api.DataScreen.getUserpdf(data);
      if (resData.code == 200) {
        this.reportStatus = 1;
        this.time = setInterval(() => {
          this.downloadPdf('polling')
        }, 5000);
      } else {
        this.reportStatus = 1;
      }
    },
    /** 轮询或手动下载已生成的个人 PDF */
    async downloadPdf(type) {
      let data = {
        userId: this.$route.query.userId,
        termIndex: this.$route.query.termKey,
        examType: this.$route.query.reportValue,
        examId: this.$route.query.monthValue,
        version: this.$route.query.term_type
      }
      data = this.withPreview(data, { ignoreTableType: true });
      let resData = await this.$Api.DataScreen.getDownloadpdf(data);
      if (resData.data != null) {
        this.reportStatus = 2;
        if (this.time) {
          clearInterval(this.time); // 清除定时器
        }
        if (type == 'btn') window.open(resData.data)
      }

    },
    /** 历次测评散点 ownexam、各维度最低分评语；并按四象限阈值统计次数供报告类型判定 */
    async getStuCompareData() {
      let that = this;
      const id = this.$route.query.userId;

      if (!id) {
        console.warn('缺少 userId，无法请求数据');
        return;
      }

      const url = `https://spark-test.deploy.lezhireading.com/statistics/static/results/ownexam/${id}`;

      try {
        const response = await axios.get(url, {
          params: {
            noCache: Date.now()
          },
          timeout: 50000,
          headers: {
            'Accept': 'application/json'
          }
        });
        if (!response || response.status !== 200 || !response.data || !Array.isArray(response.data.data)) {
          throw new Error('接口响应异常：data 非数组或为空');
        }
        const data = response.data;
        // 请根据实际接口结构调整判断条件
        if (!data.data || !Array.isArray(data.data)) {
          console.warn('接口返回数据格式不正确，data 字段缺失或非数组', data);
          return; // 不赋值，也不继续执行
        }
        that.ownexam = data.data;
        const currentItem = this.CurrentEvaluationId
          ? data.data.find(item => item.test_id === this.CurrentEvaluationId)
          : null;
        const refItem = currentItem || data.data[0];
        that.grade = getGradeFromTermId(refItem && refItem.term_id);

        if (that.ownexam.length > 0) {
          that.findLowestWithComments(that.ownexam);
        } else {
          that.commentList = [];
        }
        let xiangxian1 = 0;
        let xiangxian2 = 0;
        let xiangxian3 = 0;
        let xiangxian4 = 0;
        const countall = this.ownexam.length;

        for (let i = 0; i < this.ownexam.length; i++) {
          const item = this.ownexam[i];
          const itemGrade = resolveItemGrade(item, this.grade);
          const quadrant = classifyQuadrantIndex(item.x, item.y, itemGrade);
          if (quadrant === 1) {
            xiangxian1 += 1;
          } else if (quadrant === 2) {
            xiangxian2 += 1;
          } else if (quadrant === 3) {
            xiangxian3 += 1;
          } else if (quadrant === 4) {
            xiangxian4 += 1;
          }
        }

        this.xiangxian1 = xiangxian1;
        this.xiangxian2 = xiangxian2;
        this.xiangxian3 = xiangxian3;
        this.xiangxian4 = xiangxian4;
        this.countall = countall;
      } catch (error) {
        console.error('请求失败或数据处理出错:', error.message || error);
      }
    },
    /** 班级维度统计 + 本页象限次数 → reportType（规则与 GradeAnalysisSch_Compare 一致） */
    async getowntypebyclass() {
      await this.getStuCompareData();
      const classID = this.$route.query.classID;
      const userID = this.$route.query.userId;

      if (!classID || !userID) {
        console.warn('缺少必要参数: classID 或 userId');
        return;
      }

      const url = `https://spark-test.deploy.lezhireading.com/statistics/static/results/owntypebyclass/${classID}`;

      try {
        const response = await axios.get(url, {
          params: { noCache: Date.now() },
          timeout: 50000,
          headers: { 'Accept': 'application/json' }
        });
        if (!response || response.status !== 200 || !response.data || !response.data.data) {
          throw new Error('接口响应格式错误或数据为空');
        }
        const list = response.data.data;
        if (!Array.isArray(list)) {
          console.warn('owntypebyclass 接口返回的 data 不是数组', response.data);
          return;
        }

        const student = list.find(item => item.user_id == userID);
        if (!student) {
          console.warn(`在班级数据中未找到 user_id 为 ${userID} 的学生`);
          return;
        }
        // student：range_x/y 努力/天赋累计，std_deviation_x/y 标准差；本页 this.xiangxian* / countall 为散点四象限计数
        // 与 GradeAnalysisSch_Compare.vue 保持一致的优先级规则
        if (
          (this.xiangxian3 / this.countall >= 0.5) ||
          (student.range_x < -5 && student.range_y < -5) ||
          (student.range_y < -10 && this.xiangxian1 / this.countall < 0.6)
        ) {
          this.reportType = '重点型';
          return;
        }
        if (student.std_deviation_x >= 8 || student.std_deviation_y >= 8) {
          this.reportType = '波动型';
          return;
        }
        if (
          (this.xiangxian2 / this.countall >= 0.4) ||
          (student.range_y > 5 && student.range_x <= 0)
        ) {
          this.reportType = '天赋型';
          return;
        }
        if (

          this.xiangxian1 / this.countall >= 0.6 &&
          student.range_x >= 2 &&
          student.range_y >= 2
        ) {
          this.reportType = '双优型';
          return;
        }
        if (
          (student.range_x >= 6 && student.range_y <= 3) ||
          (this.xiangxian4 / this.countall >= 0.4 && student.range_x > 0)
        ) {
          this.reportType = '进取型';
          return;
        }
        if (
          student.range_x > 0 &&
          student.range_y > 0 &&
          student.std_deviation_x < 8 &&
          student.std_deviation_y < 8
        ) {
          this.reportType = '稳健型';
          return;
        }
        if (
          (this.xiangxian1 / this.countall > 0.2 && this.xiangxian3 / this.countall > 0.1) ||
          (student.range_y < 0 && student.range_x >= 0) ||
          (student.range_x < 0 && student.range_y >= 0) ||
          (student.range_x < 0 && student.range_y < 0 && this.xiangxian1 / this.countall > 0.3)
        ) {
          this.reportType = '潜能型';
          return;
        }
        this.reportType = '重点型';

      } catch (error) {
        console.error('获取 onwtypebyclass 数据失败:', error.message || error);
      }
    },
    /** 按维度取历次测评中得分最低的一次，匹配 commentRules 生成「具体问题与建议」 */
    findLowestWithComments(data) {
      if (!Array.isArray(data) || data.length === 0) {
        this.commentList = [];
        return;
      }
      const result = [];
      const metrics = {
        "居中占格": d => d.center_pos + d.grid_size,
        "组合关系": d => d.combo_rel,
        "收放关系": d => d.rewind_rel,
        "笔画关系": d => d.stroke_rel,
        "多画等距": d => d.multi_dist,
        "字形重心": d => d.glyph_grav
      };
      // 各维度评语规则
      const commentRules = {
        "居中占格": [
          { limit: 65, text: "中，呈现出大部分书写字迹撑格或偏格问题。", method: "解决方法：首先，我们可以在书写先找字的中心笔画，并对应田字格交点。其次我们可以找上下左右的笔画，书写时注意笔画与格子留空，且间距近乎一致。" },
          { limit: 70, text: "中，呈现出个别字占格不居中，偶尔还有字过大（过小）的现象。", method: "解决方法：我们书写时可以根据字形特征来定位字格关系，注意上下留空要一致，左右留空需均等。且每个字的与格的空间也需要保持近乎一致，这样通篇看上去就更统一规范了。" }
        ],
        "组合关系": [
          { limit: 60, text: "中，复合字部件之间的穿插避让出现明显偏差，导致字过松或过紧。", method: "解决方法：左右结构左部右收让右，右部左侧笔画收短让左。上部开展避让，下部上方笔画简短保持穿插的同时，让整字组合紧凑。同时要注意部件之间的间距，不可过大显松散，也不可过紧显局促。" },
          { limit: 65, text: "中，复合字部件之间出现过松（过紧）的情况。", method: "解决方法：上下结构穿插避让要注意上部下方笔画尽量平齐，下部上方笔画尽量收缩，且注意部件之间的间距。左右结构注意左让右，和右让左的关系。也可以通过部首特征来提升复合字的组合。让复合结构的汉字更具整体美。" }
        ],
        "收放关系": [
          { limit: 50, text: "中，呈现测评字整字笔画之间长短差异小，非同方向的笔画间距趋同，缺少张弛之美。", method: "解决方法：（1）书写前观察，辨明需舒展的主笔与需紧凑的部位；在心里形成笔画主次的层级对比。（2）提前划分布局，紧收和舒展区域笔画之间的布局，将空间划分为紧凑和舒朗的对比，让字迹有节奏与灵动性。" },
          { limit: 55, text: "中，呈现测评字收放不够明显（过于夸张）的现象。", method: "解决方法：在观察汉字收放关系维度的同时，也要注意长短和疏密的比例关系，保持和规范字模的统一性，不可过度夸张。你的字也将更具张弛美。" }
        ],
        "笔画关系": [
          { limit: 60, text: "中，笔画呼应不够明显，笔画主次不够清晰，笔画位置关系不够准确。", method: "解决方法：通过窍门找准笔画之间的呼应关系，通过观察对比规范字摸找准主笔，一般主笔为最长的笔画，且多为最上最下最左最右的笔画。通过田字格的横中线和竖中线，辅助观察笔画之间的位置关系。" },
          { limit: 63, text: "中，出现笔画呼应不够明显，笔画位置关系仍需更加准确。", method: "解决方法：可以借助窍门观察笔画直接的呼应关系，在仔细观察每个笔画之间的间距和衔接位置，让书写变得更流畅。" }
        ],
        "多画等距": [
          { limit: 55, text: "中，出现同向笔画未平行，等距间距偏差明显，未做到多画等距。", method: "解决方法：通过控笔练习，协调手腕运动和手指动作，让同向笔画保持平衡，加强起收练习，和观察训练，提升多画间距稳定性。" },
          { limit: 60, text: "中，出现距间距略有偏差。", method: "解决方法：通过控笔练习，找准发力点。调整笔画间距的距离，让字更精致，也让书写变得更轻松。" }
        ],
        "字形重心": [
          { limit: 55, text: "中，出现字形重心严重偏斜。", method: "解决方法：可以通过横平竖直来解决大部分字的重心问题，当遇到复合字时可以用于田字格的横中线和竖中线来建立字的轴中心，让字做到上下对正，左右对称或均衡。逐步让字的重心归于平衡。" },
          { limit: 60, text: "中，出现字形重心偏斜现象。", method: "解决方法：可以借助田字格的横中线和竖中线来建立字的轴中心，让字笔画之间找准平衡点。逐步让字更具端庄美。" }
        ]
      };
      // 遍历每个维度
      Object.entries(metrics).forEach(([metricName, calc]) => {
        const minItem = data.reduce((a, b) => (calc(a) < calc(b) ? a : b));
        const score = calc(minItem);
        const rules = commentRules[metricName];

        // 判断评语
        let comment = "";
        let method = "";
        if (rules) {
          for (const rule of rules) {
            if (score < rule.limit) {
              comment = rule.text;
              method = rule.method;
              break;
            }
          }
        }

        // 只有匹配区间的才加入结果数组
        if (comment) {
          result.push({
            name: minItem.name,
            score,
            comment,
            method
          });
        }
      });
      this.commentList = result;
    }
  },
  mounted() {
    // 先拉总览与单字，再异步拉历次对比与报告类型（依赖路由 classID 等）
    this.syncPreviewFlagFromRoute();
    this.getStuData();
    this.getUserWordsRecord();
    this.currentTime = moment().format("YYYY.MM.DD");
    this.currentWord = this.defaultWordInfo
    this.changeCurrentWord();
    this.getowntypebyclass();
  },
  beforeDestroy() {
    if (this.time) {
      clearInterval(this.time);
      this.time = null;
    }
  },
};
</script>
<style lang="less" scoped>
.stu-report-refactor {
  background-color: #f4f7f9;

  &.scroll-container {
    min-height: 100vh;
    overflow-y: scroll;
    scroll-snap-type: y mandatory;
  }

  .scroll-page {
    min-height: 100vh;
    scroll-snap-align: start;
  }

  .top {
    width: 100%;
    height: 60px;
    background: linear-gradient(-90deg, #00b384, #01b791);

    .logo {
      width: 126px;
      margin-left: 203px;
    }
  }

  .report-time {
    line-height: 50px;
    padding: 0 100px;
    background-color: #fff;
    text-align: right;
    color: #c2c2c2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;

    .download {
      cursor: pointer;

      img {
        width: 21px;
        margin-right: 11px;
      }

      font-size: 15px;
      color: #999;
    }

    .ReportGenerationTime {
      &>span {
        display: inline-block;

        &:last-child {
          margin-left: 35px;
        }
      }
    }

  }

  .title {
    text-align: center;
    font-weight: bold;
    font-size: 30px;
    color: #00b589;
    line-height: 81px;
  }

  .main-wrapper {
    padding: 0 203px;
    height: 80%;
    overflow: hidden;
  }

  .main {
    height: 100%;
    background-color: #fff;
    border-radius: 20px;
    padding: 64px 55px;
    box-sizing: border-box;
  }

  .score-item {
    --score-main-size: 56px;
    --score-sub-size: 25px;
    --score-caption-size: 29px;

    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: center;
    margin-right: 40px;
    color: #fff;
    width: 345px;
    height: 255px;
    padding: 20px 16px;
    box-sizing: border-box;
    font-family: "Microsoft YaHei";
    line-height: 1.2;
    text-align: center;

    &:first-child {
      background-image: url("../../assets/report/bg-2.png");
      background-repeat: no-repeat;
      background-size: cover;
    }

    &:nth-child(2) {
      background-image: url("../../assets/report/bg-1.png");
      background-repeat: no-repeat;
      background-size: cover;
    }

    &:last-child {
      background-image: url("../../assets/report/bg-3.png");
      background-repeat: no-repeat;
      background-size: cover;
      margin-right: 0;
    }

    .score-card-inner {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      flex: 1;
      min-height: 0;
    }

    .score-value {
      display: flex;
      flex-wrap: wrap;
      align-items: baseline;
      justify-content: center;
      margin: 0;
      flex-shrink: 0;
    }

    .score-main-num {
      font-size: var(--score-main-size);
      // font-weight: bold;
      line-height: 1;
    }

    .score-unit {
      font-size: var(--score-sub-size);
      margin-left: 6px;
      line-height: 1;
      align-self: baseline;
      font-weight: normal;
    }

    .score-name {
      width: 100%;
      margin: 20px 0 0;
      font-size: var(--score-caption-size);
      font-weight: normal;
      line-height: 1.35;
      min-height: calc(var(--score-caption-size) * 1.35);
    }

    .score-name--empty {
      visibility: hidden;
    }
  }

  .line {
    flex-shrink: 0;
    width: 1px;
    height: 161px;
    background: #d2d2d2;
    margin: 0 87px 0 79px;
    align-self: center;
  }

  .level {
    width: 219px;
    height: 258px;
    margin-right: 57px;
  }

  .bottom-panel {
    margin-top: 40px;
    padding-left: 20px;
    padding-right: 2px;
    width: 100%;
    box-sizing: border-box;

    .panel-item {
      width: 45%;
      padding: 0 2px;
    }

    h5 {
      font-size: 26px;
      font-weight: 600;
      color: #666;
    }

    .table {
      border: 1px solid #e7e7e7;
      border-radius: 10px;
      margin-top: 40px;

      ::v-deep th.el-table__cell {
        background: rgba(1, 181, 140, 0.1);
        color: rgba(1, 181, 140, 1);
        font-size: 21px;
        font-weight: 400;
      }

      ::v-deep .el-table--striped {
        background-color: #eeeeee;
      }

      ::v-deep .el-table__cell {
        font-size: 19px;
        color: #333;
        border-bottom: 0;

        div {
          line-height: 40px;
        }
      }

      ::v-deep .el-table__footer-wrapper tbody td.el-table__cell {
        border-top: 0;
        background-color: #fcfcfc;
        font-weight: 600;
      }

      ::v-deep .el-table__footer-wrapper tbody th.el-table__cell.gutter {
        background-color: #fcfcfc;
      }
    }
  }

  .second-wrapper {
    padding: 27px 203px;
    height: 100%;
    box-sizing: border-box;
  }

  .second-main {
    padding: 25px 55px;
  }

  .top-module {
    .toolbar {
      align-items: flex-start;

      .img-preview {
        display: none;
      }
    }

    .test-paper-btn {
      background: #f8f8f8;
      border-radius: 10px;
      padding: 0 22px 0 49px;
      line-height: 36px;
      color: #01b58c;
      position: relative;

      &:hover {
        background: rgba(248, 248, 248, 0.5);
      }

      &::before {
        content: " ";
        position: absolute;
        left: 23px;
        top: 50%;
        transform: translateY(-50%);
        width: 18px;
        height: 24px;
        background-image: url("../../assets/report/dianji-shouzhi@2x.png");
      }
    }

    .structure-list {
      padding: 0 7px;
    }

    .structure-item {
      font-family: "Microsoft YaHei";
      font-size: 19px;
      width: 120px;
      height: 45px;
      border-radius: 10px 10px 0 0;
      background: #f8f8f8;
      color: #999999;
      margin-right: 8px;
      justify-content: center;
      cursor: pointer;

      &:last-child {
        margin-right: 0;
      }

      &.active {
        color: #fff;
        background: #01b58c;
      }

      .structure-icon {
        margin-right: 3px;
        width: 20px;
      }
    }

    .all-words {
      border-radius: 10px;
      border: 1px solid #e7e7e7;
      padding: 20px 35px;
    }

    .checked-group {
      ::v-deep(.el-checkbox) {
        margin-right: 58px;

        .el-checkbox__input.is-focus .el-checkbox__inner {
          border-color: #00b384;
        }

        .el-checkbox__inner {
          width: 18px;
          height: 18px;
          vertical-align: 2px;

          &:hover {
            border-color: #00b384;
          }
        }

        &.is-checked {
          .el-checkbox__label {
            color: #00b384;
          }

          .el-checkbox__inner {
            background-color: #00b384;
            border-color: #00b384;

            &::after {
              width: 5px;
              height: 10px;
              top: 0px;
              left: 5px;
            }
          }
        }

        .el-checkbox__input.is-indeterminate .el-checkbox__inner {
          background-color: #00b384;
          border-color: #00b384;

          &::before {
            top: 7px;
          }
        }

        .el-checkbox__label {
          font-size: 18px;
        }
      }
    }

    .filter-right {
      align-items: center;
      gap: 14px;
    }

    .recognition-fail-btn {
      position: relative;
      padding: 4px 12px;
      font-size: 15px;
      font-weight: 400;
      font-family: "Microsoft YaHei", sans-serif;
      line-height: 1.35;
      color: #909399;
      background: #f4f5f7;
      border: 1px solid #e4e7ed;
      border-radius: 8px;
      box-shadow: none;
      cursor: pointer;
      transition:
        color 0.2s ease,
        background 0.2s ease,
        border-color 0.2s ease,
        box-shadow 0.2s ease,
        transform 0.15s ease;

      &:hover {
        color: #606266;
        background: #ebeef5;
        border-color: #dcdfe6;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
      }

      &:active {
        transform: scale(0.98);
      }

      &:focus {
        outline: none;
      }

      &:focus-visible {
        box-shadow: 0 0 0 2px rgba(144, 147, 153, 0.35);
      }

      &.active {
        font-weight: 500;
        color: #fff;
        border-color: transparent;
        background: linear-gradient(135deg, #00b384 0%, #01b791 100%);
        box-shadow: 0 2px 8px rgba(1, 181, 140, 0.3);

        &:hover {
          color: #fff;
          background: linear-gradient(135deg, #00a87a 0%, #019e7a 100%);
          box-shadow: 0 3px 10px rgba(1, 181, 140, 0.36);
        }

        &:focus-visible {
          box-shadow:
            0 2px 8px rgba(1, 181, 140, 0.25),
            0 0 0 2px rgba(1, 181, 140, 0.35);
        }
      }
    }

    .tips {
      color: #999;
      font-size: 17px;

      img {
        vertical-align: -8px;
      }
    }

    .words {
      margin-top: 23px;
      display: grid;
      grid-template-columns: repeat(7, 1fr);
      column-gap: 52px;
      row-gap: 27px;
      height: 330px;
      overflow: auto;
      padding-bottom: 5px;
    }

    .word-item {
      width: 143px;
      height: 143px;
      border: 3px solid #ff8181;
      position: relative;
      cursor: pointer;

      &.activeWord,
      &:hover {
        border: 3px solid #01b58c;
      }

      .word-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        /* 图片宽度填满容器 */
        height: 100%;
        /* 图片高度填满容器 */
      }
    }

    .score-bg {
      position: absolute;
      right: -27px;
      top: -5px;

      .score {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -75%);
        color: #fff;
        font-size: 23px;
        font-weight: 600;
        font-style: italic;
      }
    }
  }

  .bottom-module {
    flex: 1;

    h5 {
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 26px;
      color: #666666;
      margin: 20px 0;
    }

    .comment {
      border-radius: 10px;
      border: 1px solid #e7e7e7;
      padding: 25px 55px;
      flex: 1;
    }

    .dimension-scores {
      flex: 1;
    }

    .dimension-scores-item {
      margin: 0 75px;
      text-align: center;

      &:first-child {
        margin-left: 0;

        .dimension-scores-value {
          color: #d38e09;
        }
      }

      &:last-child {
        margin-right: 0;

        .dimension-scores-value {
          color: #4ba7f5;
        }
      }

      &:nth-child(2) .dimension-scores-value {
        color: #f88396;
      }

      &:nth-child(3) .dimension-scores-value {
        color: #48dacf;
      }
    }

    .dimension-scores-value {
      font-size: 58px;
      margin-top: 8px;
      line-height: 1;
    }

    .star-value {
      border-radius: 40px;
      background-color: rgba(238, 238, 238, 0.25);
      padding: 8px 61px;

      .star {
        margin-right: 14px;

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .character-comparison {
      margin-top: 25px;
      flex: 1;
    }

    .left-btn {
      border-radius: 50%;
      width: 40px;
      height: 40px;
      border: 3px solid #e7e7e7;
      color: #e7e7e7;
      text-align: center;
      font-weight: 600;
      cursor: no-drop;

      &.able {
        border: 3px solid #36c3a3;
        color: #36c3a3;
        cursor: pointer;

        &:hover {
          color: #fff;
          background-color: #36c3a3;
          border: 3px solid #36c3a3;
        }
      }

      .el-icon-arrow-left,
      .el-icon-arrow-right {
        font-size: 28px;
        line-height: 37px;
      }
    }

    .characers {
      flex: 1;
      justify-content: space-around;
    }

    .characer-title {
      font-size: 20px;
      color: #999999;
      margin-bottom: 17px;
      text-align: center;
    }

    .characer-item {
      position: relative;
      width: 143px;
      height: 143px;

      .characer-img {
        position: absolute;
        top: 0;
        left: 0;
        border: 1px solid skyblue;
        // width: 135px;
        // height: 135px;
        // max-width: 100%;
        width: 100%;
        height: 100%;

      }

    }

    .StudentMatrix {
      .StudentMatrix_title {
        font-size: 22px;
        color: #666666;
        font-weight: bold;
        margin: 20px 0;
      }

      .StudentMatrix-box {
        width: 100%;
        height: 800px;
        position: relative;
      }
    }



  }

  .SummaryAndSuggestions {
    font-size: 22px;
    color: #333;
    font-weight: bold;
    margin-bottom: 12px;
  }

  .SummaryAndSuggestions_text {
    font-size: 18px;
    color: #666;
    line-height: 30px;
    // text-indent: 2em;
    // margin-top: 12px;
  }

  .Whole {
    font-size: 18px;
    color: #333;
    font-weight: bold;
    margin-bottom: 12px;
    margin-top: 12px;
  }

  .Whole_Details {
    margin: 18px 0;
  }

  .Content {
    // border: 1px solid #000;
    padding: 0 40px;
  }
}
</style>